import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(8.000000, 8.000000) rotate(-180.000000) translate(-8.000000, -8.000000) ">
          <g transform="translate(2.000000, 4.666667)">
            <mask id="arrow-mask" fill="white">
              <path d="M10.4958533,0.495853295 L5.99933333,4.992 L1.50369119,0.49628667 C1.28686083,0.279456309 0.934916948,0.279456309 0.718075517,0.49629774 C0.501234087,0.71313917 0.501234087,1.06508305 0.718075517,1.28192448 L5.60696441,6.17081337 C5.7135775,6.27634474 5.8544416,6.33333333 6,6.33333333 C6.14663078,6.33333333 6.28852584,6.27551331 6.39379676,6.16915711 L11.28148,1.28148004 C11.4983215,1.06463861 11.4983215,0.712694726 11.28148,0.495853295 C11.0646386,0.279011865 10.7126947,0.279011865 10.4958533,0.495853295 Z" />
            </mask>
            <g mask="url(#arrow-mask)">
              <g transform="translate(-2.000000, -4.666667)">
                <rect id="Rectangle" fill="currentColor" x="0" y="0" width="16" height="16" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
